"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_filepicker_add_fileprovider_1 = require("owa-filepicker-add-fileprovider");
var addFileProvider = null;
// Importing it here because addAndSelectFileProvider needs to call the addFileProvider in the same context as the event
// that triggered it. This is done to ensure that popup blocker does not get invoked.
function initAddFileProvider() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            owa_filepicker_add_fileprovider_1.lazyAddFileProvider.import().then(function (func) { return (addFileProvider = func); });
            return [2 /*return*/];
        });
    });
}
exports.initAddFileProvider = initAddFileProvider;
// If the addFileProvider function was loaded early then return that so that
// the popup blocker does not get invoked else we load it and return it
// which will invoke the popup blocker but that is much less likely to happen.
function getAddFileProvider() {
    return addFileProvider
        ? { isAsync: false, result: addFileProvider }
        : { isAsync: true, result: owa_filepicker_add_fileprovider_1.lazyAddFileProvider.import() };
}
exports.getAddFileProvider = getAddFileProvider;
//# sourceMappingURL=lazyAddFileProviderHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/utils/lazyAddFileProviderHelper.js
// module id = 1804
// module chunks = 2 3 43 106 107